import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getStoreTitleDetails } from '@bingads-webui-campaign-react/wizard-shared-components';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStoreInfoStyle = () => ({
  storeTitleDetails: {
    whiteSpace: 'normal',
  },
});

export const StoreInfo = ({ data }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStoreInfoStyle);

  const {
    ProviderId,
    IsFeedFiltered,
    SalesCountry,
    FeedLabel,
    LocalInventoryAdsEnabled,
    storesData,
  } = data || {};

  const storeContainerData = useMemo(() => ({
    ProviderId,
    IsFeedFiltered,
    SalesCountry,
    FeedLabel,
    LocalInventoryAdsEnabled,
  }), [ProviderId, IsFeedFiltered, SalesCountry, FeedLabel, LocalInventoryAdsEnabled]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Store summary') }}>
      <div className={classes.storeTitleDetails}>{storesData && getStoreTitleDetails(i18n, storesData, storeContainerData)}</div>
    </PropertyRow>
  );
};

StoreInfo.propTypes = {
  data: PropTypes.shape({
    ProviderId: PropTypes.string,
    IsFeedFiltered: PropTypes.bool,
    SalesCountry: PropTypes.string,
    FeedLabel: PropTypes.string,
    LocalInventoryAdsEnabled: PropTypes.bool,
  }).isRequired,
};
